/**
 * L2-R7: moved to @miq/utils (lib/reports/report-name-extractors.ts). This shim keeps the old import
 * path working (including through the `./index` barrel); new code should import from '@miq/utils'.
 */
export {
  reportNameExtractor,
  serializeFolderPath,
  deserializeFolderPath,
  subTitleExtractor,
  dateFormatter,
} from '@miq/utils';
